import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@faire/web--source/slate/Button";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import ClickOutside from "@faire/web--source/ui/ClickOutside";
import React from "react";
import styled from "styled-components";
export var HeaderClickItem = function(param) {
    var clickChild = param.clickChild, children = param.children, dataTestId = param.dataTestId, ariaLabel = param.ariaLabel, toggleDropdown = param.toggleDropdown, shouldShowDropdown = param.shouldShowDropdown, shouldDisableClick = param.shouldDisableClick, onClick = param.onClick, className = param.className;
    var handleOnClick = function() {
        if (!shouldDisableClick) {
            toggleDropdown(!shouldShowDropdown, false);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    return /*#__PURE__*/ _jsxs(ClickOutside, {
        onClickOutside: function() {
            return toggleDropdown(false, true);
        },
        className: className,
        children: [
            /*#__PURE__*/ _jsx(ClickItem, {
                onClick: handleOnClick,
                "aria-label": ariaLabel,
                "data-test-id": dataTestId,
                variant: "tertiary",
                children: children
            }),
            shouldShowDropdown ? clickChild : null
        ]
    });
};
export var ClickItem = styled(Button).withConfig({
    componentId: "sc-2388061d-0"
})([
    "&:hover{cursor:pointer;}",
    "{margin-top:12px;}"
], responsiveMediaQueries.mobile);
